import { CloseOutlined } from "@ant-design/icons";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import { Button, Drawer, Space } from "antd";
import { useState } from "react";
import PageTitle from "@/components/PageTitle";

export default function LiftFaultDetailPage({
  children,
  title,
  loading,
  styles,
  width = 880,
  footer,
  drawerTitle,
  className,
}: {
  children: React.ReactNode;
  title: string;
  loading: boolean;
  styles?: any;
  width?: number;
  footer?: React.ReactNode;
  drawerTitle?: React.ReactNode;
  className?: string;
}) {
  const pevContext = useOutletContext<{
    callBackFunc?: (isReach?: boolean) => void;
  }>();
  const navigation = useNavigate();
  const { state } = useLocation();
  const [open, setOpen] = useState(true);
  const onClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
      width={width}
      loading={loading}
      onClose={onClose}
      open={open}
      className={className}
      destroyOnClose
      closeIcon={<></>}
      afterOpenChange={(isShow) => {
        if (!isShow) {
          pevContext?.callBackFunc?.(!state?.callUrl);
          navigation(state?.callUrl || -1);
        }
      }}
      styles={styles || { body: { padding: "0px 40px 20px 40px" } }}
      footer={footer}
      title={drawerTitle}
      extra={
        <Space>
          <Button onClick={onClose} color="default" variant="link">
            <CloseOutlined
              className="text-[#000000d9] dark:text-[#ffffff73]"
              style={{ fontSize: 24 }}
            />
          </Button>
        </Space>
      }
    >
      <PageTitle title={title} />
      {children}
    </Drawer>
  );
}
